module.exports = __webpack_public_path__ + "static/img/41-北京第二实验小学(新文化街校区).ee58197.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/41-北京第二实验小学(新文化街校区).png
// module id = Tuvp
// module chunks = 0